import { errorifInvalidPin } from "../../pinUtils"
import { baseApiRequest } from "../baseApiRequest"
const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export async function pinQueryFunction<TResponse>(path: string, pin: string | null) {
  errorifInvalidPin(pin)
  const url = `${origin}/api/${path}`

  return baseApiRequest<TResponse>({
    url,
    init: {
      headers: {
        'Authorization': `Bearer ${pin}`,
        'Content-Type': 'application/json'
      },
    },
    trackingEvent: 'usePinApiQuery',
  })
}
